import { VehicleCapacityType } from '@sparelabs/domain-logic'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
import { IVehicleAccessibilityFeature } from './AccessibilityTypes'

export enum VehicleOwner {
  Organization = 'organization',
  User = 'user',
}

export enum VehicleStatus {
  Active = 'active',
  Archived = 'archived',
}

/**
 * Type is duplicated from EAM rather than re-used to avoid circular dependencies
 * Having a separate definition here also reminds us to perform migrations on both systems when this changes
 */
export enum VehicleAssetStatus {
  Active = 'active',
  Inactive = 'inactive',
  InMaintenance = 'inMaintenance',
  OutOfService = 'outOfService',
  Sold = 'sold',
}

export enum VehicleType {
  Sedan = 'sedan',
  Minivan = 'minivan',
  PassengerVan = 'passengerVan',
  Bus = 'bus',
}

export enum VehicleFuelType {
  Gas = 'gas',
  Electric = 'electric',
  Hybrid = 'hybrid',
}

export interface IVehiclePostBody {
  accessibilityFeatures: IVehicleAccessibilityFeature[]
  color: string
  identifier: string
  licensePlate: string
  make: string
  model: string
  ownerUserId: string | null
  passengerSeats: number
  photoUrl?: string | null
  emissionsRate?: number | null
  capacityType?: VehicleCapacityType
  vehicleTypeId?: string | null
  metadata?: Record<string, unknown>
  /** on creation, eamAssetId can be provided to connect the vehicle to an existing EAM asset, if ID does not exist, new EAM asset will be created async */
  eamAssetId?: string | null
  providerId?: string | null
}

export interface IVehiclePatchBody {
  accessibilityFeatures?: IVehicleAccessibilityFeature[]
  color?: string
  identifier?: string
  licensePlate?: string
  make?: string
  model?: string
  ownerUserId?: string | null
  passengerSeats?: number
  photoUrl?: string | null
  status?: VehicleStatus
  emissionsRate?: number | null
  capacityType?: VehicleCapacityType
  vehicleTypeId?: string | null
  metadata?: Record<string, unknown>
  eamAssetId?: string
  providerId?: string | null
}

export interface IVehicleListQueryParams extends IListModelQueryParamValues {
  status?: VehicleStatus
  ownerUserId?: string
  identifier?: string
  external?: boolean
  search?: string
  eamAssetId?: string
  providerId?: string | null
}

export interface IVehicleStub {
  id: string
  accessibilityFeatures: IVehicleAccessibilityFeature[]
  color: string
  identifier: string
  licensePlate: string
  make: string
  model: string
  passengerSeats: number
  photoUrl: string | null
  hasFullAccess: boolean
  vehicleTypeId: string | null
  assetStatus: VehicleAssetStatus
}

export interface IVehicleResponse extends IModelJsonValues, IVehiclePostBody {
  ownerType: VehicleOwner
  status: VehicleStatus
  emissionsRate: number | null
  eamAssetId: string | null
  providerId: string | null
  assetStatus: VehicleAssetStatus
}

// Backwards compatibility
export interface IVehicle extends IVehicleResponse {}
